module.exports = __webpack_public_path__ + "static/img/02.a83caeb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/02-productCenter-tzzM/02.jpg
// module id = ybRp
// module chunks = 1